import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";

export class OddsTypeDropdownItemProps extends BaseProps {
  item;
  active: Boolean;
  name: String;
  onClick: Function;
}

export const OddsTypeDropdownItem = (props: OddsTypeDropdownItemProps) => {
  const containerProps = {
    className: ['odds-type-dropdown-item', (props.item.active ? 'odds-type-dropdown-item-active' : '')].join(' '),
    onClick: () => props.item.onClick(props.item.name)
  };

  return (
    <div {...containerProps}>
      {
        props.item.name
      }
    </div>
  )
};
